/* eslint-disable react-hooks/exhaustive-deps */
// @ts-expect-error CSS imports are handled by the bundler/tooling in this project
import './App.css';
import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import { initializeUserpilot } from 'utils/userpilotClient';
import RouterConfig from 'router';
declare global {
  interface Window {
    Intercom: any;
  }
}

function App() {
 
  React.useEffect(() => {
    initializeUserpilot();
  }, []);

  return (
    <Router>
      <RouterConfig />
    </Router>
  );
}

export default App;
